
import { ServiceStatus } from '../types/service.type';

interface StatusConfig {
  label: string;
  color: string;
  bgColor: string;
  borderColor: string;
  textColor: string;
  animated?: boolean;
}

export const SERVICE_STATUS_CONFIG: Record<ServiceStatus, StatusConfig> = {
  deploying: {
    label: 'Deploying',
    color: 'bg-blue-500',
    bgColor: 'bg-blue-50',
    borderColor: 'border-blue-200',
    textColor: 'text-blue-800',
    animated: true,
  },
  initializing: {
    label: 'Initializing',
    color: 'bg-blue-500',
    bgColor: 'bg-blue-50',
    borderColor: 'border-blue-200',
    textColor: 'text-blue-800',
    animated: true,
  },
  stacking: {
    label: 'Creating',
    color: 'bg-blue-500',
    bgColor: 'bg-blue-50',
    borderColor: 'border-blue-200',
    textColor: 'text-blue-800',
    animated: true,
  },
  creating: {
    label: 'Creating',
    color: 'bg-blue-500',
    bgColor: 'bg-blue-50',
    borderColor: 'border-blue-200',
    textColor: 'text-blue-800',
    animated: true,
  },
  running: {
    label: 'Running',
    color: 'bg-green-500',
    bgColor: 'bg-green-50',
    borderColor: 'border-green-200',
    textColor: 'text-green-800',
  },
  active: {
    label: 'Active',
    color: 'bg-green-500',
    bgColor: 'bg-green-50',
    borderColor: 'border-green-200',
    textColor: 'text-green-800',
  },
  stopped: {
    label: 'Stopped',
    color: 'bg-gray-400',
    bgColor: 'bg-gray-50',
    borderColor: 'border-gray-200',
    textColor: 'text-gray-700',
  },
  stopping: {
    label: 'Stopping',
    color: 'bg-yellow-500',
    bgColor: 'bg-yellow-50',
    borderColor: 'border-yellow-200',
    textColor: 'text-yellow-800',
    animated: true,
  },
  starting: {
    label: 'Starting',
    color: 'bg-blue-500',
    bgColor: 'bg-blue-50',
    borderColor: 'border-blue-200',
    textColor: 'text-blue-800',
    animated: true,
  },
  restarting: {
    label: 'Restarting',
    color: 'bg-orange-500',
    bgColor: 'bg-orange-50',
    borderColor: 'border-orange-200',
    textColor: 'text-orange-800',
    animated: true,
  },
  error: {
    label: 'Error',
    color: 'bg-red-500',
    bgColor: 'bg-red-50',
    borderColor: 'border-red-200',
    textColor: 'text-red-800',
  },
  terminated: {
    label: 'Terminated',
    color: 'bg-red-700',
    bgColor: 'bg-red-50',
    borderColor: 'border-red-300',
    textColor: 'text-red-900',
  },
  deleting: {
    label: 'Deleting',
    color: 'bg-red-600',
    bgColor: 'bg-red-50',
    borderColor: 'border-red-300',
    textColor: 'text-red-800',
    animated: true,
  },
  deleted: {
    label: 'Deleted',
    color: 'bg-red-800',
    bgColor: 'bg-red-50',
    borderColor: 'border-red-400',
    textColor: 'text-red-900',
  },
  maintenance: {
    label: 'Maintenance',
    color: 'bg-orange-500',
    bgColor: 'bg-orange-50',
    borderColor: 'border-orange-200',
    textColor: 'text-orange-800',
  },
};

export const getStatusConfig = (status: ServiceStatus | string): StatusConfig => {
  // Normalizar el status a minúsculas para comparación
  const normalizedStatus = status?.toLowerCase() || '';
  
  // Mapear estados genéricos que vienen del backend
  // ACTIVE -> running, INACTIVE -> stopped
  if (normalizedStatus === 'active') {
    return SERVICE_STATUS_CONFIG.active;
  }
  if (normalizedStatus === 'inactive') {
    return SERVICE_STATUS_CONFIG.stopped;
  }
  
  // Mapear estados de creación a 'deploying' para usar la misma configuración
  const statusKey = normalizedStatus === 'initializing' || 
                    normalizedStatus === 'stacking' || 
                    normalizedStatus === 'creating'
                    ? 'deploying' 
                    : (normalizedStatus as ServiceStatus);
  
  const config = SERVICE_STATUS_CONFIG[statusKey as ServiceStatus];
  
  // Si el status no está definido, retornar un valor por defecto
  if (!config) {
    // Si es un estado de creación no reconocido, usar la configuración de deploying
    if (normalizedStatus === 'initializing' || normalizedStatus === 'stacking' || normalizedStatus === 'creating') {
      return SERVICE_STATUS_CONFIG.deploying;
    }
    
    return {
      label: status || 'Unknown',
      color: 'bg-gray-400',
      bgColor: 'bg-gray-50',
      borderColor: 'border-gray-200',
      textColor: 'text-gray-700',
    };
  }
  return config;
};